import { Icon, Typography } from '@mui/material'
import classNames from 'classnames'
import React, { ReactElement } from 'react'
import { Button } from 'react-aria-components'
import { useTranslation } from 'react-i18next'

import styles from './InfoBox.module.less'

type InfoBoxProps = {
  infoHeader?: string | React.JSX.Element
  onInfoButtonClick?: () => void
  beta?: boolean
  wantToLearnMoreText?: string
}

export default function InfoBox({
  infoHeader,
  onInfoButtonClick,
  beta,
  wantToLearnMoreText,
}: InfoBoxProps): ReactElement {
  const { t } = useTranslation()

  return (
    <div className={styles.InfoBox_TitleAndInfo}>
      {infoHeader && (
        <Typography variant="h1" className={styles.InfoBox_InfoHeader}>
          {beta ? <span className={styles.InfoBox_Beta}>Beta</span> : <></>}
          {infoHeader}
        </Typography>
      )}
      {onInfoButtonClick && (
        <Button className={styles.InfoBox_InfoButton} onClick={onInfoButtonClick}>
          <Icon fontSize="small" className={classNames(`fas fa-info-circle`, styles.InfoBox_InfoButtonIcon)} />
          <Typography variant="subtitle2" className={styles.InfoBox_InfoButtonText}>
            {wantToLearnMoreText ? wantToLearnMoreText : t(`I want to learn more`)}
          </Typography>
        </Button>
      )}
    </div>
  )
}
